import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';

// Initialize analytics with Google Analytics
const analytics = Analytics({
  app: 'Applied BAS Website',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-6YCM127R7L']
    })
  ]
});

// Track page views
export const trackPageView = (path) => {
  analytics.page({
    title: document.title,
    path: path
  });
};

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  analytics.track(eventName, properties);
};

// Identify users (for when you have user data)
export const identifyUser = (userId, traits = {}) => {
  analytics.identify(userId, traits);
};

export default analytics;